// Firebase configuration validation utility
export const validateFirebaseConfig = () => {
  const config = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  };

  const missing = [];
  const present = [];

  Object.entries(config).forEach(([key, value]) => {
    if (!value || value === '') {
      missing.push(key);
    } else {
      present.push(key);
    }
  });

  // Only log Firebase config status in development
  if (process.env.NODE_ENV === 'development') {
    // console.log('Firebase Configuration Status:');
    // console.log('✅ Present:', present);
    if (missing.length > 0) {
      // console.log('❌ Missing:', missing);
      // console.log('Please add the missing environment variables to your .env file');
    } else {
      // console.log('✅ All Firebase configuration variables are present');
    }
  }

  return {
    config,
    isValid: missing.length === 0,
    missing,
    present,
  };
};

// Export the configuration for use in other files
export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};
